import initGalleryModal from "./modalSliders";

export default function initFacets() {
  document.addEventListener("facetwp-loaded", function () {
    initGalleryModal();
  });
}
